import React from "react";
import {Grid, IconButton} from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {ErrorBoundary} from "react-error-boundary";

import {Download, Error, Preview, PrintOptionsForm, TabManager} from "./Components";
import {useAppStore} from "./Stores";
import {getLabelTypes} from "./Utils";

export const AppForm: React.FC = () => {
  const labelTypes = getLabelTypes();
  const setLabelType = useAppStore.use.setLabelType();

  return (
    <>
      <Grid
        spacing={4}
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item md={6} xs={12}>
          <div className="card">
            { labelTypes.length > 1 && (
              <IconButton onClick={() => setLabelType('')} className="back-button">
                <ArrowBackIosNewIcon />
              </IconButton>
            )}

            <div>
              <ErrorBoundary FallbackComponent={Error}>
                <PrintOptionsForm />
              </ErrorBoundary>

              <h2>Étiquettes</h2>

              <ErrorBoundary FallbackComponent={Error}>
                <TabManager />
              </ErrorBoundary>

              <ErrorBoundary FallbackComponent={Error}>
                <Download />
              </ErrorBoundary>
            </div>
          </div>
        </Grid>

        <Grid item md={4} xs={12}>
          <ErrorBoundary FallbackComponent={Error}>
            <Preview />
          </ErrorBoundary>
        </Grid>
      </Grid>
    </>
  );
}

export default AppForm;
